import { connect } from 'react-redux';
import View from './DetailedAssetAllocationView';
import { goalId as selectedGoalId } from '../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import { chartDataSelector, legendSelector } from './DetailedAssetAllocationSelector';
import { setDetailedAssetAllocationOpen } from '../WhatIfsActions';
import { loading, nullableFpIdSelector, detailedAssetAllocationOpenSelector } from '../WhatIfsSelector';

const mapStateToProps = (state, ownProps) => ({
  fpId: nullableFpIdSelector(state, ownProps),
  goalId: selectedGoalId(state, ownProps),
  loading: loading(state, ownProps),
  detailedAssetAllocationOpen: detailedAssetAllocationOpenSelector(state, ownProps),
  chartData: chartDataSelector(state, ownProps),
  legend: legendSelector(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  onDismiss: clientId => () => {
    dispatch(setDetailedAssetAllocationOpen(clientId, false));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);
